// Diese Datei wird automatisch generiert. Nicht manuell bearbeiten.
export const APP_VERSION = "v1.11.20260310132522";
